import {
  ShiftDeleteFragment,
  ShiftFragment,
  ShiftUpdateFragment,
} from '@/graphql/custom-types';
import {
  GetShiftsDocument,
  GetShiftsQueryVariables,
  ScheduleShiftInput,
  ShiftDeleteDocument,
  ShiftUpdateDocument,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getShifts = async (
  variables: GetShiftsQueryVariables
): Promise<ShiftFragment[]> => {
  const response = await apolloClient.query({
    query: GetShiftsDocument,
    variables,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  if (response.data.schedule?.shifts) {
    return response.data.schedule.shifts as ShiftFragment[];
  }

  throw new SentryGraphQLError(`api.workSchedule.getShifts`, response);
};

const shiftUpdate = async (
  shift: ScheduleShiftInput
): Promise<ShiftUpdateFragment> => {
  const response = await apolloClient.mutate({
    mutation: ShiftUpdateDocument,
    variables: { shift },
    errorPolicy: 'all',
  });

  if (response.data?.shift?.update) {
    return response.data.shift.update;
  }

  throw new SentryGraphQLError(`api.workSchedule.shiftUpdate`, response);
};

const shiftDelete = async (id: string): Promise<ShiftDeleteFragment> => {
  const response = await apolloClient.mutate({
    mutation: ShiftDeleteDocument,
    variables: { id },
    errorPolicy: 'all',
  });

  if (response.data?.shift?.delete) {
    return response.data.shift.delete;
  }

  throw new SentryGraphQLError(`api.workSchedule.shiftDelete`, response);
};

export default {
  getShifts,
  shiftUpdate,
  shiftDelete,
};
